import axios from 'axios'

export default async ({ url, headers, filename = 'Rappi' }) => {
  const { data } = await axios.get(url,{ headers, responseType: 'blob' });
  const blob = new Blob([data], { type: 'application/pdf' });
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  link.click()
  URL.revokeObjectURL(link.href)
};
